export var isElementScrollable = function (_a) {
    var element = _a.element;
    return !!element && element.scrollWidth > element.offsetWidth;
};
export var isElementFullyVisible = function (_a) {
    var scrollableElement = _a.scrollableElement, childElement = _a.childElement;
    return !!scrollableElement &&
        !!childElement &&
        childElement.offsetLeft >= scrollableElement.scrollLeft &&
        childElement.offsetLeft + childElement.offsetWidth <=
            scrollableElement.scrollLeft + scrollableElement.offsetWidth;
};
export var isElementScrollableToTheLeft = function (_a) {
    var element = _a.element;
    return !!element && element.scrollLeft > 0;
};
export var isElementScrollableToTheRight = function (_a) {
    var element = _a.element;
    return !!element && Math.ceil(element.scrollLeft) < Math.ceil(element.scrollWidth - element.offsetWidth);
};
export var scrollElementLeftBy = function (_a) {
    var element = _a.element, _b = _a.scrollByPercentage, scrollByPercentage = _b === void 0 ? 0.7 : _b;
    if (!element)
        return;
    element.scrollBy({ left: -(element.offsetWidth * scrollByPercentage), behavior: 'smooth' });
};
export var scrollElementRightBy = function (_a) {
    var element = _a.element, _b = _a.scrollByPercentage, scrollByPercentage = _b === void 0 ? 0.7 : _b;
    if (!element)
        return;
    element.scrollBy({ left: element.offsetWidth * scrollByPercentage, behavior: 'smooth' });
};
export var scrollElementIntoView = function (_a) {
    var element = _a.element, _b = _a.smooth, smooth = _b === void 0 ? false : _b;
    if (!element)
        return;
    element.scrollIntoView({
        behavior: smooth ? 'smooth' : undefined,
        inline: 'center',
    });
};
export var scrollElementIntoViewWithinContainer = function (_a) {
    var element = _a.element, container = _a.container, _b = _a.offset, offset = _b === void 0 ? 0 : _b, _c = _a.enforceMiddle, enforceMiddle = _c === void 0 ? false : _c;
    if (!element || !container)
        return;
    var elementWidth = element.offsetWidth;
    var containerWidth = container.offsetWidth;
    var isFullyVisible = element.offsetLeft >= container.scrollLeft + offset &&
        element.offsetLeft + elementWidth + offset < containerWidth + container.scrollLeft;
    if (enforceMiddle || isFullyVisible) {
        container.scrollTo({
            left: element.offsetLeft - (containerWidth - elementWidth) / 2,
            behavior: 'smooth',
        });
    }
    else if (containerWidth < elementWidth || container.scrollLeft + offset >= element.offsetLeft) {
        container.scrollTo({
            left: element.offsetLeft - offset,
            behavior: 'smooth',
        });
    }
    else {
        container.scrollTo({
            left: element.offsetLeft - containerWidth + elementWidth + offset,
            behavior: 'smooth',
        });
    }
};
//# sourceMappingURL=scroll.js.map